import * as tslib_1 from "tslib";
import { CollectionField } from './collection_field';
import { EditableField } from '../form/editable/editable_field';
var GridField = /** @class */ (function (_super) {
    tslib_1.__extends(GridField, _super);
    function GridField(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        var keys = 'caption,captionTemplate,editor,readonly,require,draggable,frozen,sortable,sortOrder,resizeable';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                if (key === 'editor') {
                    _this[key] = new EditableField(obj[key]);
                }
                else {
                    _this[key] = obj[key];
                }
            }
        });
        return _this;
    }
    GridField.prototype.toJSON = function () {
        var result = {
            "type": "GridField",
            "caption": this.caption,
            "captionTemplate": this.captionTemplate,
            "editor": null,
            "readonly": this.readonly,
            "require": this.require,
            "draggable": this.draggable,
            "frozen": this.frozen,
            "sortable": this.sortable,
            "sortOrder": this.sortOrder,
            "resizeable": this.resizeable
        };
        if (this.editor) {
            result["editor"] = this.editor.toJSON();
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), result);
    };
    GridField.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return GridField;
}(CollectionField));
export { GridField };
//# sourceMappingURL=grid_field.js.map